import { autobind } from 'core-decorators';
import { Component } from 'react';

import ControlApplications from '/@/components/control-applications';
import Message from '/@/components/message';
import { _, _lazy } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class PestControl extends Component {
    static label = _lazy('Control de plagas');
    static icon = 'pest';

    render() {
        const { pestControlPlans } = this.props;
        if (!pestControlPlans.data) return null;
        return <div className={styles.root}>{pestControlPlans.data.results.map(this.renderControlPlan)}</div>;
    }

    renderControlPlan(controlPlan) {
        return (
            <div key={controlPlan.id} className={styles.pest}>
                <div className={styles.title}>{_(controlPlan.pest.name)}</div>
                <div className={styles.configurations}>
                    {controlPlan.cropStage && (
                        <div>
                            <div className={styles.label}>{_('Estadio del cultivo')}:</div>
                            <span className={styles.value}>{_(controlPlan.cropStage)}</span>
                        </div>
                    )}
                    {controlPlan.damageLevel && (
                        <div>
                            <div className={styles.label}>{_('Nivel de daño')}:</div>
                            <span className={styles.value}>{_(controlPlan.damageLevel)}</span>
                        </div>
                    )}
                    {controlPlan.pestSize && (
                        <div>
                            <div className={styles.label}>{_('Tamaño')}:</div>
                            <span className={styles.value}>{_(controlPlan.pestSize)}</span>
                        </div>
                    )}
                    {controlPlan.seedTreatment && (
                        <div>
                            <div className={styles.label}>{_('Tratamiento de semilla')}:</div>
                            <span className={styles.value}>{_(controlPlan.seedTreatment)}</span>
                        </div>
                    )}
                </div>
                <div className={styles.applications}>{this.renderApplications(controlPlan.applications)}</div>
                <div className={styles.notes}>
                    {controlPlan.notes.map((note) => (
                        <Message key={note.id} type={note.type} showIcon>
                            {_(note.text)}
                        </Message>
                    ))}
                </div>
            </div>
        );
    }

    renderApplications(applications) {
        const windowKeys = [];
        const windows = {};

        applications.forEach((application) => {
            const key = `${application.windowStart}-${application.windowEnd}`;
            if (!windowKeys.includes(key)) {
                windowKeys.push(key);
                windows[key] = {
                    index: windowKeys.length,
                    start: application.windowStart,
                    end: application.windowEnd,
                    products: [],
                };
            }
            windows?.[key]?.products.push({
                index: windows?.[key]?.products.length + 1,
                name: _(application.product),
                dose: application.dose,
                unit: _(application.doseUnit),
            });
        });

        const getWindowTitle = ({ start, end }) => {
            if (start === end) return _('{{start}}', { start });
            return _('{{start}} - {{end}}', { start, end });
        };
        return (
            <ControlApplications
                data={windowKeys.map((windowKey) => ({
                    windows: [
                        {
                            title: getWindowTitle(windows[windowKey]),
                            items: windows?.[windowKey]?.products.map((product) => {
                                return (
                                    <div>
                                        <strong>{product.name}</strong>
                                        <br />
                                        {product.dose} {product.unit}
                                    </div>
                                );
                            }),
                        },
                    ],
                }))}
            />
        );
    }
}
